var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorAssets04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#006885;}.cls-2{fill:#003b55;}.cls-3{fill:#00a8e5;}.cls-4,.cls-5{isolation:isolate;}.cls-5{font-size:71.67px;fill:#fff;font-family:AvenirNext-Bold, Avenir Next;font-weight:700;letter-spacing:-0.03em;}.cls-6{letter-spacing:-0.01em;}.cls-7{letter-spacing:-0.03em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201-2",
    "data-name": "Path 201-2",
    className: "cls-1",
    d: "M179,33.3C104.6,33.7,44.7,92,45,163.7l.8,156.4L315,318.8l-.8-156.5C313.8,90.7,253.3,32.9,179,33.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    className: "cls-2",
    d: "M65.6,240.6,175.9,11.9,287.8,239.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    className: "cls-3",
    d: "M124.5,144.5l106.1-.5L178.9,245.8Zm0,0L177,34.6,230.6,144Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Career",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(66.3 296.6) rotate(-0.3)"
  }, "C", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 47.9,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 87.7,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 114.1,
    y: 0
  }, "eer"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorAssets04);
export default __webpack_public_path__ + "static/media/Vector Assets-04.facbaea42d3b4446f8d69f214d61eee3.svg";
export { ForwardRef as ReactComponent };